import React from 'react';
import styled from 'styled-components';
import { COLOR } from '../../utils/constants';
import { parseContent } from '../../utils/helpers';
import Section from '@latitude/section-rebrand';
import Typography from '@latitude/typography';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';

const ApplyEligibilityWrapper = styled.div`
  background-color: ${REBRAND_COLOR.STONE};
  padding: 32px 0;
`;

const ApplyEligibilityTitleSection = styled(Section)`
  background-color: ${REBRAND_COLOR.STONE};
`;
const ApplyEligibilityBodySection = styled(Section)`
  margin-top: 32px !important;
`;

const ApplyEligibilityBody = styled.div`
  padding: 32px;
  background-color: ${REBRAND_COLOR.WHITE};
`;

const TitleRow = styled.div`
  display: flex;
`;

const List = styled.ul`
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
`;

const Item = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  p li {
    list-style: disc;
  }
  p ul {
    padding-left: 20px !important;
  }
`;

const ItemBody = styled.div`
  margin-left: 48px;
`;

const NumberCircle = styled.div`
  padding: 3px 11.5px;
  background-color: ${REBRAND_COLOR.INDIGO};
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  height: fit-content;
`;

const ApplyEligibility = props => {
  const { title, data, bgColor = COLOR.BLUE, id } = props;

  return (
    <ApplyEligibilityWrapper id={id}>
      <ApplyEligibilityTitleSection>
        {' '}
        <Typography.SH1 semibold color={REBRAND_COLOR.BLACK}>
          {title}
        </Typography.SH1>
      </ApplyEligibilityTitleSection>
      <ApplyEligibilityBodySection>
        <ApplyEligibilityBody>
          <List>
            {data.map((item, i) => (
              <Item key={i}>
                <TitleRow>
                  <NumberCircle>
                    <Typography.Body color={REBRAND_COLOR.WHITE}>
                      {i + 1}
                    </Typography.Body>
                  </NumberCircle>
                  <Typography.SH4 semibold color={REBRAND_COLOR.BLACK}>
                    {item.title}
                  </Typography.SH4>
                </TitleRow>
                <ItemBody>
                  <Typography.Body color={REBRAND_COLOR.BLACK}>
                    {parseContent(item.description)}
                  </Typography.Body>
                </ItemBody>
              </Item>
            ))}
          </List>
        </ApplyEligibilityBody>
      </ApplyEligibilityBodySection>
    </ApplyEligibilityWrapper>
  );
};

export default ApplyEligibility;
